import { dateFormatter } from '../../../shared/formatters';
import config from '../../../config';

const formatDate = (date?: Date) =>
  date ? dateFormatter(date, config.AMERICAN_DATE_TIME_FORMAT) : '-';

export default formatDate;
